var EventEmitterMixin = require("../../mixins/event-emitter.mixin");
var WishlistTable = require("./wishlist-table");

var WishlistForm = function () {
    var self = this;
    var $currentContext = $();
    var moduleOptions = {};
    var classMap = {
        submitButton: ".js-wishlist-form__submit-button",
        selectButton: ".js-wishlist-form__submit-button",
        selectAllButton: ".js-wishlist-form__select-all",
        addToCartInputs: ".js-wishlist-entry__add-to-cart-checkbox"
    };

    var wishlistTable;
    var $addToCartInputs,
        $submitButton,
        $selectButton,
        $selectAllButton,
        $form;

    this.rejectProduct = function (product) {
        wishlistTable.getEntries().forEach(entry => {
            if (entry.getProduct().id === product.id) {
                entry.setAddToCartMarker(false);
            }
        });
    };

    this.sendProductsToCart = function () {
        $("<input/>", {
            type: "hidden",
            name: "addtocartbutton",
            value: "Add to cart"
        }).appendTo($form);

        $form.submit();
    };

    this.removeProductFromCart = function () {
        $("<input/>", {
            type: "hidden",
            name: "updatecart",
            value: "Update wishlist"
        }).appendTo($form);

        $form.submit();
    };

    function handleSelectButtonsState() {
        if ($addToCartInputs.is(":checked")) {
            $selectButton.removeAttr("disabled");
        }
        else {
            $selectButton.attr("disabled", "disabled");
        }
    }

    function bindEvents() {
        $submitButton.on("click", function (e) {
            e.preventDefault();
            var entries = wishlistTable
                .getEntries()
                .filter(entry => entry.getAddToCartMarker() === true);
            self._raiseEvent("form-submitted", entries);
        });

        wishlistTable.on("entry-removed", function () {
            self._raiseEvent("entry-removed");
        });

        $addToCartInputs.on("change", handleSelectButtonsState);
        $selectAllButton.on("change", handleSelectButtonsState);
    }

    function parseContext() {
        $form = $currentContext;
        $submitButton = $(classMap.submitButton, $form);
        $selectButton = $(classMap.selectButton, $form);
        $selectAllButton = $(classMap.selectAllButton, $form);
        $addToCartInputs = $(classMap.addToCartInputs, $form);

        var $wishlistTableContext = $(WishlistTable.SELECTOR, $currentContext);
        wishlistTable = new WishlistTable();
        wishlistTable.init($wishlistTableContext, moduleOptions);
    }

    this.init = function (context, options) {
        $currentContext = context || $currentContext;
        $.extend(moduleOptions, options);

        parseContext();
        bindEvents();
        handleSelectButtonsState();
    };
};

Object.assign(WishlistForm.prototype, new EventEmitterMixin());

Object.defineProperty(WishlistForm, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-wishlist-form"
});

module.exports = WishlistForm;
